export default {
    // apiUrlBetaV2: "http://localhost:3000/production/", 
    // apiUrl: "https://bm02tiursf.execute-api.ap-south-1.amazonaws.com/beta/api/collection/", 
    // apiUrlBetaV2: 'https://p7nci91o1k.execute-api.ap-south-1.amazonaws.com/production/api/collection/',
    apiUrlBetaV2:"https://api.services.stucred.com/collections-v2/",
    // apiUrlBetaV2:"https://beta.api.services.stucred.com/collectionv2/",
    appName: "My React App",
    version: "1.0.0"
  };